import { render, staticRenderFns } from "./OrderReferenceSearchBox.vue?vue&type=template&id=0a50aa18&"
import script from "./OrderReferenceSearchBox.vue?vue&type=script&lang=js&"
export * from "./OrderReferenceSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports